export default __webpack_public_path__ + "static/media/advantage-2.cb491101.png";